import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { OPTION_TYPES_COMPANY } from '../Company';
// styles
import * as styles from './OptionTypeSwitcher.scss';

const OptionTypeSwitcher = (props) => {
  const { title, hasPropertiesForSale, hasPropertiesForRent } = props;

  const renderOptionTypeButton = (optionType) => (
    <button
      className={cx(
        styles.optionTypeButton,
        { [styles.activeButton]: props.activeOption === optionType }
      )}
      onClick={props.handleSelectOption}
      value={optionType}
    >
      {props.translate(optionType)}
    </button>
  );

  const separator = (hasPropertiesForSale && hasPropertiesForRent)
    ? (<span className={styles.separator} />)
    : '';

  return (
    <div className={styles.optionTypeSwitcher}>
      <div>{title}&nbsp;</div>
      {hasPropertiesForSale && renderOptionTypeButton(OPTION_TYPES_COMPANY.SALE)}
      {separator}
      {hasPropertiesForRent && renderOptionTypeButton(OPTION_TYPES_COMPANY.RENT)}
    </div>
  );
};

OptionTypeSwitcher.propTypes = {
  translate: PropTypes.func,
  title: PropTypes.string,
  activeOption: PropTypes.string,
  hasPropertiesForSale: PropTypes.bool,
  hasPropertiesForRent: PropTypes.bool,
  handleSelectOption: PropTypes.func,
  className: PropTypes.string
};

export default OptionTypeSwitcher;
